import { render, staticRenderFns } from "./ModalidadeField.vue?vue&type=template&id=e5aa8f76&scoped=true&"
import script from "./ModalidadeField.vue?vue&type=script&lang=js&"
export * from "./ModalidadeField.vue?vue&type=script&lang=js&"
import style0 from "./ModalidadeField.vue?vue&type=style&index=0&id=e5aa8f76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5aa8f76",
  null
  
)

export default component.exports